import React from 'react';

type Props = { children?: React.ReactNode };

const LeftContent: React.FC<Props> = ({ children }) => <div className="body-left">{children}</div>;

export default LeftContent;
